import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { client, errorValidation } from "./service.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getTerms({ orderTypes = [], categories = [], merchantId = '', placeId = '' }) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/term-and-conditions`,
      params: {
        orderTypes,
        categories,
        merchantId,
        placeId,
      }
    });

    if (response.statusCode !== 200) { throw response.data; }
    let data = response.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getTerm(id) {
  try {
    let response = await client.get(`/term-and-condition/${id}`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function createTerm(body) {
  try {
    let response = await client.post(`/term-and-condition/create`, {
      ...body
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    console.log('error on termssss', e)
    return errorValidation(e)
  }
}

export async function updateTerm(body) {
  try {
    let response = await client.post(`/term-and-condition/update`, {
      ...body
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function updateTermIndex(body) {
  try {
    let response = await client.post(`/term-and-condition/update-index`, {
      ...body
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}